export default __webpack_public_path__ + "static/SubpageBanners_WhyCollins-747997e3ea04998de99c1de8686008d9.jpg";